import {useCallback} from "react";
import {useAuth} from "@clerk/react";
import {api} from "@/lib/inner";

export const useCmsApi = () => {
  const {getToken} = useAuth();
  return useCallback(async (method, url, data) => (await api({method, url: `/cms${url}`, data, headers: {Authorization: `Bearer ${await getToken()}`}})).data, [getToken]);
};

export const errMsg = e => {
  const d = e.response?.data?.detail;
  return Array.isArray(d) ? "Periksa kembali isian formulir." : d || "Gagal menyimpan. Coba lagi.";
};

export const Field = ({label, testid, ...props}) => <label>{label}<input data-testid={testid} {...props}/></label>;

export const ActiveSwitch = ({checked, onChange, testid}) => (
  <label className="active-switch"><input type="checkbox" data-testid={testid} checked={checked} onChange={e => onChange(e.target.checked)}/> Tampilkan ke pelanggan</label>
);

export const FormActions = ({onCancel, saving, testid}) => (
  <div className="cms-form-actions">
    <button type="submit" className="primary-btn" data-testid={`${testid}-save`} disabled={saving}>{saving ? "Menyimpan…" : "Simpan"}</button>
    <button type="button" className="secondary-btn" data-testid={`${testid}-cancel`} onClick={onCancel}>Batal</button>
  </div>
);
